export default __webpack_public_path__ + "static/ak-cached/24h/media/acc_hero_image.b226fdf4.jpg";